// Runtime environment variables, injected into window.__ENV__ by /env-config.js.
//
// In Docker, /env-config.js is regenerated on every container start by
// docker-entrypoint.sh from the PG_ADMIN_* env vars (see .env / .env.*).
// For local dev the defaults in public/env-config.js are used.
const env = (typeof window !== "undefined" && window.__ENV__) || {};

export const PG_ADMIN_API_BASE_URL = env.PG_ADMIN_API_BASE_URL || "";
export const PG_ADMIN_WS_BASE_URL = env.PG_ADMIN_WS_BASE_URL || "";
export const PG_MERCHANT_API_BASE_URL = env.PG_MERCHANT_API_BASE_URL || "";

export default env;
